import {AbstractSubscriptionPayment, SubscriptionConfirmationPayment} from '../subscription.confirmation.payment';
import {Lead} from '../../../../../data/domain/lead';
import {isCompleteFor, isForbiddenAgedClient, isForbiddenPreviousClient} from '../../../../../common/sessions';
import {createE164PhoneNumber} from '../../../../../common/strings';
import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {SubscriptionResources} from '../../../../../resources/subscription.resources';
import {LeadResources} from '../../../../../resources/lead.resources';
import {RemoteConfig} from '../../../../config/remote-config';
import {ErrorReportingApi} from '../../../../../common/api/error-reporting.api';
import {SocialTrackService} from '../../../../../services/social-track.service';

@Injectable({
  providedIn: 'root',
})
export class OfferSubscription extends AbstractSubscriptionPayment implements SubscriptionConfirmationPayment {

  leadResources = inject(LeadResources)
  remoteConfig = inject(RemoteConfig)
  errorReportingApi = inject(ErrorReportingApi);

  constructor() {
    super(inject(SubscriptionResources), inject(PLATFORM_ID), inject(SocialTrackService));
  }

  isEligible(): boolean {
   return true
  }

  async pay(): Promise<any> {

    this.socialTrackService.trackGAEvent('pay_offer')
    if (this.checkEligibility() && this.checkContext()) {
      const leadDTO = this.leadResources.currentLead.value()
      const calculatedPrice = this.subscriptionResources.calculatePrice.value()
      const isComplete = isCompleteFor(this.sessionDTO, leadDTO)
      const forbiddenAge = isForbiddenAgedClient(this.sessionDTO, leadDTO?.age)
      const isUnauthorized = isForbiddenPreviousClient(this.sessionDTO, this.subscriptionResources.calculatePrice.value()?.oldClient)
      const phoneNumber = this.context.confirmationForm ? createE164PhoneNumber(this.context.confirmationForm.controls.phone.value) : leadDTO.phone

      if (!isComplete && !forbiddenAge && !isUnauthorized) {
        if (calculatedPrice?.totalDiscount === 0 || this.referralCode != null) {
          await this.confirmAndThanks(leadDTO)
        } else {
          this.context.paymentContext.set({
            authenticationInProgress: true, loading: true, captured: false, error: null, orderCreated: false, loaded: false
          })
          await this.authByPhone.authenticate(phoneNumber, async (isSuccess) => {
            if (isSuccess) {
              this.context.paymentContext.set({
                authenticationInProgress: false, loading: false, captured: false, error: null, orderCreated: false, loaded: false
              })
              await this.confirmAndThanks(leadDTO)
            } else {
              this.actions.failWithMessage("Erreur d'authentification par télephone, veuillez retenter.", null)
            }
          })
        }
      } else if (isComplete){
        await this.actions.waitSubscriptionOnCompleteAge()
      } else if(forbiddenAge) {
        await this.actions.waitSubscriptionOnForbiddenAge()
      } else if(isUnauthorized) {
        await this.actions.waitSubscriptionOnUnauthorizedOldClient()
      }
    }
  }

  private async confirmAndThanks(leadDTO: Lead) {
    this.context.paymentContext.set({loaded: false, orderCreated: false, loading: true, error: null, captured: false, authenticationInProgress: false})
    const payMode = leadDTO?.subscription?.paid ? null : 'none'
    await this.actions.sendSubscriptionAndThanks(leadDTO, payMode)
  }

}
